<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2023-12-20 16:53:36
!-->
<template>
  <div id="index" class="index">
    <div class="bannerLogo" style="max-width: 100%;min-width: 1240px; margin: auto">
      <!-- <el-carousel height="464px" indicator-position="none" :interval="5000">
        <el-carousel-item>
          <img src="../../assets/img/banner_lcl@2x(1).png" width="1440px" height="240px">
        </el-carousel-item>
      </el-carousel> -->
      <div v-if="!isSteps">
        <div class="title-one">Where would you like to ship?</div>
        <div class="title-two">Start searching to compare, book and manage your freight, all on one platform
        </div>
      </div>
      <div v-if="isSteps" class="steps-class">
        <Steps ref="Steps" :active="active" @step="step" />
        <!-- <el-steps :active="active">
          <el-step title="Search"></el-step>
          <el-step title="Recommended Services"></el-step>
          <el-step title="Results"></el-step>
          <el-step title="Booking"></el-step>
          <el-step title="Verification"></el-step>
        </el-steps> -->
      </div>
    </div>
    <div class="paddTop250" style="display: flex; justify-content: center; margin-top:calc(-208px + 16px) ">
      <CheckPrice ref="CheckPrice" @step="step" />
    </div>
    <!-- 查价结果 -->
    <div v-if="isShowResult" class="results-main">
      <Results ref="Results" :data="list" :input-data="inputData" />
    </div>
    <div v-if="isNoData">
      <NoResults />
    </div>
  </div>
</template>

<script>
import NoResults from './noResults.vue'
import Steps from './steps.vue'
import Results from './results/index.vue'
import CheckPrice from './checkPrice/index.vue'
import {
  setCookie
} from '@/utils/cookiejs'
import {
  Activate
} from '../../api/user.js'
export default {
  name: 'Index',
  components: { // 组件的引用
    CheckPrice,
    Results,
    Steps,
    NoResults
  },
  props: { // 父辈向子辈传参
  },
  data() {
    return {
      navTopAtv: false,
      isSteps: false, // 是否显示进度条
      active: 5,
      isShowResult: false, // 是否显示结果
      cId: '', // 客户id
      list: [],
      inputData: null,
      isNoData: false
    }
  },
  computed: { // 计算属性

  },
  watch: { // 监测变化

  },
  created() { // 实例被创建之后执行代码
    var cId = this.getQueryString('cId')
    var type = this.getQueryString('t')
    var step = this.getQueryString('step')
    var isLogin = this.getQueryString('login')
    var isRegister = this.getQueryString('register')
    if (isLogin && isLogin == 1) {
      this.$store.commit('user/DIALOG_VISIBLE', true)
    }
    if (isRegister && isRegister == 1) {
      this.$store.commit('user/STARTED_VISIBLE', true)
    }
    if (type === 'f') {
      var resetToken = this.getQueryString('tk')
      setCookie('isResetPwd', true)
      setCookie('resetToken', resetToken)
      this.$store.commit('user/DIALOG_VISIBLE', true)
    }
    if (cId) {
      this.cId = cId
      this.activate()
    }
    if (step) {
      var inputData = undefined
      var result = undefined
      if (step === '2') {
        if (localStorage.getItem('queryInput')) {
          inputData = JSON.parse(localStorage.getItem('queryInput'))
        }

        if (localStorage.getItem('queryResult')) {
          result = JSON.parse(localStorage.getItem('queryResult'))
        }
      }
      this.step(true, parseInt(step), result, inputData)
    }
  },
  mounted() { // 页面进入时加载内容

  },
  methods: { // 方法
    step(isOk, val, data, inputData) {
      this.active = val
      this.isSteps = isOk
      if (val === 0) {
        this.isSteps = false
      } else {
        this.isSteps = true
      }
      if (data) {
        if (data.list.length === 0) {
          this.isNoData = true
          this.isShowResult = false
        } else {
          this.isShowResult = true
          this.$nextTick(() => {
            this.$refs.Results.init(data, inputData)
          })
        }
      } else {
        this.isNoData = false
        this.isShowResult = false
      }
      this.$nextTick(() => {
        this.$refs.CheckPrice.init(val)
        if (inputData) {
          this.$refs.CheckPrice.checkprice(inputData, false)
        }
      })
    },
    goToManage() {
      const nativeHref = this.$router.resolve({
        path: `manage`
        // query,
      })
      // checkPriceLink(this, nativeHref.href, true);
      const w = window.open()
      w.location.href = nativeHref.href
    },
    // 获取页面参数
    getQueryString(key) {
      // 创建 URLSearchParams 对象并传入当前页面的 URL
      const params = new URLSearchParams(window.location.hash.split('?')[1])

      // 通过 get() 方法获取指定参数名称的值
      return params.get(key) // 'paramName'为要获取的参数名称
    },
    // 客户激活
    activate() {
      Activate(this.cId).then(res => {
        setCookie('token', res.data)
        setTimeout(function() {
          window.location.href = window.location.hash.split('?')[0]
        }, 500)
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.index {
		.paddTop250 {
			padding-top: 90px;
		}

		.bannerLogo {
			width: auto;
			height: 200px;
			background: url("../../assets/img/banner_lcl@2x(1).png");
			background-size: cover;
			padding-top: 40px;

			.title-one {
				font-size: 24px;
				font-family: D-DINExp, D-DINExp;
				font-weight: bold;
				color: #FFFFFF;
				height: 40px;
				line-height: 40px;
			}

			.title-two {
				font-size: 14px;
				font-family: D, D;
				font-weight: normal;
				color: rgba(255, 255, 255, 0.8);
				height: 40px;
				line-height: 40px;
			}

			.steps-class {
				width: 1000px;
				text-align: left;
				margin: 0 auto;

				::v-deep .el-steps {
					.el-step {
						z-index: 0;

						.is-process {
							.el-step__icon {
								background: #E95506 !important;
							}
						}

						.is-finish {
							color: #E95506;
							border-color: #E95506;

							.el-step__icon {
								background: rgba(233, 85, 6, 0.64) !important;
							}

							.el-step__line {
								background-color: #E95506 !important;
							}
						}

						.el-step__head {
							.el-step__line {
								margin: 5px 64px;
								left: -21px;
								right: 9px;
							}

							.el-step__icon {
								width: 32px;
								height: 32px;
								background: rgba(255, 255, 255, 0.16); //rgba(233,85,6,0.64);
								font-size: 18px;
								font-family: AppleSystemUIFont;
								color: rgba(255, 255, 255, 0.64);
								border: 0;
							}
						}

						.el-step__main {
							.is-process {
								color: #FFFFFF !important;
							}

							.is-finish {
								color: rgba(255, 255, 255, 0.64) !important;
							}
						}
					}

					.el-step:nth-of-type(2) {
						.el-step__main {
							position: relative;
							left: -71px;
						}
					}
				}

			}
		}

		.results-main {
			margin: 24px auto;
			width: 1200px;
			text-align: center;
		}
	}
</style>
